<div
  class="submenu-trigger"
  #triggerEl
  (mouseenter)="onTriggerEnter()"
  (mouseleave)="onTriggerLeave()"
  (click)="$event.stopPropagation()">
  <div class="content-wrapper">
    <ng-content select=".submenu-icon"></ng-content>
    <span>{{ label() }}</span>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="chevron-icon">
    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
</div>
<ng-template #submenuTemplate>
  <div
    class="submenu-panel"
    (mouseenter)="onPanelEnter()"
    (mouseleave)="onPanelLeave()"
    (click)="onPanelClick()">
    <ng-content></ng-content>
  </div>
</ng-template>
